import { render } from "./FileTable.vue?vue&type=template&id=483519e8&scoped=true&ts=true"
import script from "./FileTable.vue?vue&type=script&lang=ts"
export * from "./FileTable.vue?vue&type=script&lang=ts"

import "./FileTable.vue?vue&type=style&index=0&id=483519e8&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483519e8"]])

export default __exports__